import axios from 'axios';
import API_BASE_URL from './api';

export const purgeEmailTechnicalData = async ({ token, include_verification = true, include_reset = true }) => {
  const res = await axios.post(
    `${API_BASE_URL}/admin/email/purge`,
    { include_verification, include_reset },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
};